import * as React from 'react';
import { Props } from '@blueprint/button/dist/Button.types';

import { LoaderIcon } from './LoaderIcon';
import { StyledButtonWithLoading } from './ButtonWithLoading.styles';

interface ButtonWithLoadingProps extends Props {
    isLoading?: boolean;
    loadingText?: string;
}

export const ButtonWithLoading: React.FC<
    ButtonWithLoadingProps & JSX.IntrinsicElements['button']
> = ({ isLoading, loadingText = 'Loading', children, ...props }) => (
    <StyledButtonWithLoading
        aria-live="polite"
        isLoading={isLoading}
        {...props}
    >
        {isLoading ? (
            <>
                <LoaderIcon data-testid="spinner-icon" aria-hidden />
                {loadingText}
            </>
        ) : (
            children
        )}
    </StyledButtonWithLoading>
);
